import { Box } from '@mui/material';
import Navbar from '../navbar/Navbar';
import Footer from '../footer/Footer';
import { useState } from 'react';

export default function Layout(props:{children:any}) {
    const [menuOpen, setMenuOpen] = useState(false);

    return (
        <>
            <Navbar menuOpen={menuOpen} setMenuOpen={setMenuOpen}/>
            <Box sx={{ display: 'flex',flexDirection:'column'}}>
                <Box 
                    sx={theme => ({
                        transition: theme.transitions.create('margin-left', {
                            duration: theme.transitions.duration.standard,
                            easing: theme.transitions.easing.easeInOut,
                        }),
                        mt: 5, p:1, mb: 5, ml: menuOpen? 30:10
                        })}
                        >
                    {props.children}
                </Box>
            </Box>
            <Footer />
        </>
    )
}
